import(/* webpackMode: "eager" */ "/codebuild/output/src2695183786/src/Sagio-front/src/app/[policy]/page.js");
